import { onCtxAbort, reaction } from '@reatom/framework'
import i18next from 'i18next'

import { delugeIdAtom } from '@root/entities/auth/atoms'
import { selectedNetworkAtom } from '@root/entities/network'
import { confirmTransactionUpdateEvent } from '@root/entities/realtime'
import { dependenciesAtom } from '@root/features/shared/dependencies'
import { showSnackbarAction } from '@root/shared/ui-kit'

import { SnackbarTxHasContent } from '../../swap/ui/desktop/snackbar-tx-hash-content'

export const transactionConfirmationReaction = reaction((ctx) => {
  const { mainWebsocket } = ctx.get(dependenciesAtom)
  const delugeId = ctx.spy(delugeIdAtom)
  const network = ctx.spy(selectedNetworkAtom)
  if (!delugeId) {
    return
  }

  mainWebsocket.confirmTransactionSubscribeAction(ctx, {
    network,
    delugeId,
  })
  const unsub = confirmTransactionUpdateEvent.onCall((ctx, data) => {
    if (!data.confirmed) {
      showSnackbarAction(ctx, {
        intent: 'error',
        text: i18next.t('trading.transaction-confirmation-failed.message'),
        description: (
          <SnackbarTxHasContent network={network} txHash={data.txHash} />
        ),
        delay: 5000,
      })
    }
  })

  onCtxAbort(ctx, () => {
    mainWebsocket.confirmTransactionUnsubscribeAction(ctx, {
      network,
      delugeId,
    })
    unsub()
  })
}, 'transactionConfirmationReaction')
